/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { FetchError } from '@atlassian/jira-fetch/src/index.tsx';
import type { RestIssueType } from './IssueTypesForProjectsResponse.types.tsx';
import type { IssueTypeWithPinnedFields } from './IssueType.types.tsx';

export const transformIssueTypeResponse = (rest: RestIssueType): IssueTypeWithPinnedFields => ({
	id: String(rest.id),
	name: rest.name,
	entityId: rest.entityId,
	description: rest.description,
	avatarId: String(rest.avatarId),
	avatarUrl: rest.avatarUrl,
	hierarchyLevel: rest.hierarchyLevel,
	operation: {
		deletable: rest.operation.deletable,
		editable: rest.operation.editable,
	},
	pinnedFields: rest.pinnedFields,
});

export const isUpdatingRemovedIssueTypeError = (errorObject: unknown): boolean =>
	errorObject instanceof FetchError && errorObject.statusCode === 412;
